module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "campus-life-left.4b65e1e7.webp" + "?" + Date.now();